import {PROJ_PFX} from '@/constants'
import _ from 'lodash'
declare global {
  interface Window {[key: string]: any}
}
export function set (key: string, data: any, freeze = false) {
  if (typeof data === 'object') {
    data = _.cloneDeep(data)
  }
  window[PROJ_PFX + key] = data;
  if (freeze) {
    Object.freeze(window[PROJ_PFX + key]);
  }
}

export function remove (key: string) {
  if (window[PROJ_PFX + key]) delete window[PROJ_PFX + key];
}

export function get(key: string) {
  if (window[PROJ_PFX + key]) return window[PROJ_PFX + key];
}

const API = {
  set,
  remove,
  get
}

export default API